import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";


export const fetch_all_service_records = async () => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/service/get_all_service_records', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching vehicles:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


//-------------------------------------------------------------------------------------------------


export const use_add_new_service = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/add_new_service_record', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record added successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to create service record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_update_service = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/update_service_record', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to updated record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_update_service_status = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/update_service_status', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to updated record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_delete_service = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/delete_service_record', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record removed successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to remove record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------
export const use_upload_pdf = async (file, service_uuid, type) => {
    try {
        // Create FormData object to hold the file and associated metadata
        const formData = new FormData();
        formData.append("formData", file);  // Key should match the Flask backend's expected form name
        formData.append("serviceUuid", service_uuid);
        formData.append("type", type);

        logger.log("****Uploading file for service_uuid:", service_uuid);

        const sessionToken = await getSessionUUID(); // Use the utility function for authentication

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionToken}`, // Authorization header
            },
            body: formData, // FormData automatically handles the Content-Type header
        };

        // Send the request to the backend
        const response = await fetch('/service/upload_pdf', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Return success message and server response data
            return { 
                message: responseBody.message || 'File uploaded successfully', 
                publicUrl: responseBody.publicUrl,
                status: response.status 
            };
        } else {
            // Handle server error response
            return { 
                message: responseBody.error || 'Failed to upload file', 
                status: response.status 
            };
        }
    } catch (err) {
        logger.error("Error uploading file:", err);
        return {
            message: err.message || 'An error occurred during file upload',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const use_fetch_pdf = async (filePath) => {
    try {
        const sessionToken = await getSessionUUID(); // Assuming this fetches your auth token

        const response = await fetch('/service/get_pdf', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ file_path: filePath }),
        });

        const responseBody = await response.json();

        if (response.status === 200) {
            return {
                message: 'PDF fetched successfully',
                pdfUrl: responseBody.file_url,
                status: response.status,
            }; // The public URL or base64 string of the PDF
        } else {
            return {
                message: responseBody.error || 'Failed to fetch the PDF',
                pdfUrl: null,
                status: response.status,
            };
        }
    } catch (error) {
        logger.error('Error fetching the PDF:', error);
        return null;
    }
};

//-------------------------------------------------------------------------------------------------

export const use_update_service_future_schedule = async (service_data) => {
    try{
        // User input
        const body = {
            service_data
        };

        logger.log("****service_data", service_data);

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/update_service_future_schedule', requestOptions);
        const responseBody = await response.json();

        logger.log("****response", responseBody.data.error);

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.data.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.data.error || 'Failed to updated record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_toggle_inService = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/toggle_inService', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to update record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_add_comment = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/add_comment', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to update record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_remove_comment = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/delete_comment', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to update record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const use_toggle_vor = async (service_data) => {

    try{
        // User input
        const body = {
            service_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/service/toggle_vor', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Service record updated successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to update record', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating service schedule:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

const auditDocumentRequest = async (path, options = {}, parseJson = true) => {
    const sessionToken = await getSessionUUID();
    const response = await fetch(path, {
        ...options,
        headers: {
            'Authorization': `Bearer ${sessionToken}`,
            ...(options.headers || {}),
        },
    });
    if (!parseJson) return response;
    const responseText = await response.text();
    let data;
    try {
        data = responseText ? JSON.parse(responseText) : {};
    } catch {
        data = {
            error: response.ok
                ? 'The server returned an invalid response'
                : `Request failed with HTTP ${response.status}`,
        };
    }
    return { status: response.status, data };
};

export const fetch_audit_documents = async () => {
    try {
        return await auditDocumentRequest('/service/audit_documents');
    } catch (err) {
        logger.error('Error fetching audit documents:', err);
        return { status: 500, data: { error: err.message || 'Failed to load audit documents' } };
    }
};

export const export_audit_documents = async (startMonth, endMonth) => {
    try {
        const query = new URLSearchParams({ start: startMonth, end: endMonth });
        const response = await auditDocumentRequest(
            `/service/audit_documents/export?${query.toString()}`,
            {},
            false,
        );
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to export audit documents');
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/i);
        return {
            status: 200,
            blob: await response.blob(),
            filename: filenameMatch?.[1] || `Transport_Audit_${startMonth}_to_${endMonth}.zip`,
        };
    } catch (err) {
        logger.error('Error exporting audit documents:', err);
        return { status: 500, data: { error: err.message || 'Failed to export audit documents' } };
    }
};

export const upload_audit_document = async ({
    file,
    documentType,
    reportMonth,
    notes,
    evidenceDate,
    tachoInfringementId,
    assessmentOutcome,
}) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('document_type', documentType);
        formData.append('report_month', reportMonth);
        formData.append('notes', notes);
        if (evidenceDate) formData.append('evidence_date', evidenceDate);
        if (tachoInfringementId) formData.append('tacho_infringement_id', tachoInfringementId);
        if (assessmentOutcome) formData.append('assessment_outcome', assessmentOutcome);
        return await auditDocumentRequest('/service/audit_documents', {
            method: 'POST',
            body: formData,
        });
    } catch (err) {
        logger.error('Error uploading audit document:', err);
        return { status: 500, data: { error: err.message || 'Failed to upload audit document' } };
    }
};

export const get_audit_document_url = async (documentId) => {
    try {
        return await auditDocumentRequest(`/service/audit_documents/${documentId}/url`);
    } catch (err) {
        logger.error('Error opening audit document:', err);
        return { status: 500, data: { error: err.message || 'Failed to open audit document' } };
    }
};

export const verify_audit_document = async (documentId) => {
    try {
        return await auditDocumentRequest(`/service/audit_documents/${documentId}/verify`);
    } catch (err) {
        logger.error('Error verifying audit document:', err);
        return { status: 500, data: { error: err.message || 'Failed to verify audit document' } };
    }
};

export const delete_audit_document = async (documentId) => {
    try {
        return await auditDocumentRequest(`/service/audit_documents/${documentId}`, { method: 'DELETE' });
    } catch (err) {
        logger.error('Error deleting audit document:', err);
        return { status: 500, data: { error: err.message || 'Failed to remove audit document' } };
    }
};

export const fetch_audit_gate_checks = async (startMonth, endMonth) => {
    try {
        const query = new URLSearchParams({ start: startMonth, end: endMonth });
        return await auditDocumentRequest(`/service/audit_gate_checks?${query.toString()}`);
    } catch (err) {
        logger.error('Error fetching gate-check evidence:', err);
        return { status: 500, data: { error: err.message || 'Failed to load gate-check evidence' } };
    }
};

export const fetch_audit_gate_check_pdf = async (gateCheckId) => {
    try {
        const response = await auditDocumentRequest(
            `/service/audit_gate_checks/${gateCheckId}/pdf`,
            {},
            false,
        );
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to generate gate-check PDF');
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/i);
        return {
            status: 200,
            blob: await response.blob(),
            filename: filenameMatch?.[1] || `Gate_Check_${gateCheckId}.pdf`,
        };
    } catch (err) {
        logger.error('Error generating gate-check PDF:', err);
        return { status: 500, data: { error: err.message || 'Failed to generate gate-check PDF' } };
    }
};